(function() {
    'use strict';

    angular.module('GorillaBoy.Login')
    .controller('LoginFailedController', [
        '$scope',
        '$location',
        'EndpointService',
        LoginFailedController
    ]);

    function LoginFailedController ($scope, $location, EndpointService) {
        /*
         * Returns the main application URL
         */
        $scope.retryUrl = function () {
            var absUrl = $location.absUrl(),
                index = absUrl.indexOf('index.html');
            $scope.changeWindowLocationHref(absUrl.substring(0, index - 1));
        };
    }
    
}());